import Functions from '@client/style/Functions';
import { Breakpoints } from '@client/style/Variables';
import React from 'react';
import styled from 'styled-components';
import Embed from './Embed/Embed';

const StyledIframe = styled(Embed)`
	object-fit: cover;
	pointer-events: none;
	user-select: none;
	border: none;
	aspect-ratio: 16/9;
	width: auto !important;
	height: 100vh !important;

	${Functions.breakpoint(Breakpoints.tablet)} {
		height: auto !important;
		width: 100vw !important;
	}
`;

export default function BackgroundVideoModule(props: {
	data: {
		platform: 'youtube' | 'twentythree';
		url: string;
		className?: string;
	};
}) {
	return (
		<StyledIframe
			tabIndex={-1}
			src={props.data.url}
			embedType={props.data.platform}
			inline={true}
			className={props.data.className}
		/>
	);
}
